import http from './http'

export default {
  paymentMode: {
    getList () {
      return http.get('/payment/paymentmode/getlist')
    },
    getPaymentConfig (id) {
      return http.get('/payment/paymentmode/getpaymentconfig', {id: id})
    },
    updateConfig (model) {
      return http.post('/payment/paymentmode/updateconfig', model)
    },
    updateEnable (model) {
      return http.post('/payment/paymentmode/updateenable', model)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/payment.js